module.exports = __webpack_public_path__ + "img/kopernik-logo-white-new.bb89e121.png";